/**
 * What this session CHANGED, folded out of its own transcript.
 *
 * The fold moved to mod-core (`projection-changes.ts`) so a closing page can
 * carry it in the page seed (RFC 0360 S2); the window keeps this name.
 */

import { changesFromTranscript } from '@mod/core/log'

export {
  type ChangeKind,
  type DocumentChange,
  type FileChange,
  type FileEdit,
  lastSegments,
  mergeSessionChanges,
  type SessionChanges,
} from '@mod/core/log'

export const projectSessionChanges = changesFromTranscript
